"use strict";
exports.__esModule = true;
exports.isBillerFlexAnywhereLongTailPortal = exports.isBillerOONPortal = exports.isGenericPortal = exports.isBillerPropertyDetails = void 0;
var types_1 = require("./types");
var isBillerPropertyDetails = function (connectingProperty) {
    return connectingProperty.identity_biller_id !== undefined;
};
exports.isBillerPropertyDetails = isBillerPropertyDetails;
var isGenericPortal = function (connectingProperty) {
    return connectingProperty.generic_portal_identity_biller_id != undefined;
};
exports.isGenericPortal = isGenericPortal;
var isBillerOONPortal = function (connectingProperty) {
    var flexAnywherePortalNames = [
        types_1.FlexAnywherePortalName.FLEX_ANYWHERE.toString(),
        types_1.FlexAnywherePortalName.OUT_OF_NETWORK.toString(),
    ];
    return (flexAnywherePortalNames.includes(connectingProperty.portal_name) && connectingProperty.public_id === types_1.OON_BILLER_ID);
};
exports.isBillerOONPortal = isBillerOONPortal;
var isBillerFlexAnywhereLongTailPortal = function (connectingProperty) {
    return connectingProperty.public_id != undefined && connectingProperty.biller_id != undefined;
};
exports.isBillerFlexAnywhereLongTailPortal = isBillerFlexAnywhereLongTailPortal;
